module.exports = __webpack_public_path__ + "img/4.e65c4c25.png";